import React from "react";

import { css } from "@emotion/core";

import { SkeletonBlock } from "@zapier/design-system";

/**
 * 600x750 makes loading the change plan page in a modal look smooth. If we want a different
 * loading block for non-modal usage, we may want to add an `isInModal` prop or something
 * to the `ChangePlan` component and conditionally render an appropriate loading block.
 */
export const skeletonWrapperCss = css`
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CheckoutLoading = () => (
  <div css={skeletonWrapperCss}>
    <SkeletonBlock height={600} width={750} />
  </div>
);
